import { render, staticRenderFns } from "./roadSong.vue?vue&type=template&id=1e5310f4&"
import script from "./roadSong.vue?vue&type=script&lang=js&"
export * from "./roadSong.vue?vue&type=script&lang=js&"
import style0 from "./roadSong.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports